// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indexedStep {
  color: rgb(190, 190, 190);
  width: 20px;
  height: 20px;
  font-size: 12px;
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indexedStep.accomplished {
  background-color: #007bff;
  color: white;
  border-style: none;
}

.indexedStep.completed {
    background-color: #007bff;
    color: white;
  }

.indexedStep > svg {
  font-size: 11px;
}

.indexedStep .mt-14 {
  position: absolute;
  font-size: 12px;
  text-align: center;
}

.RSPBprogressBar {
  height: 2px;
  width: 200px;
  line-height: 1;
  border-radius: 10px;
  position: relative;
  background-color: rgb(207, 207, 207);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 0;
  margin: 20px auto;
}

.RSPBprogressBar .RSPBstep {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  position: absolute;
  transform: translateX(-50%);
  transition-property: all;
  transition-timing-function: ease;
}

.RSPBprogressBar .RSPBprogressBarText {
  color: white;
  font-size: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.RSPBprogressBar .RSPBprogression {
  position: absolute;
  transition: width 0.3s ease;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 10px;
  background: #007bff;
  z-index: -1;
}

@media screen and (max-width: 480px) {
  .indexedStep {
    width: 15px;
    height: 15px;
    font-size: 6px;
  }
}

.single-step-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}


`, "",{"version":3,"sources":["webpack://./src/components/HSN/MultiStepProgressBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;EACd;;AAEF;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,OAAO;EACP,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".indexedStep {\n  color: rgb(190, 190, 190);\n  width: 20px;\n  height: 20px;\n  font-size: 12px;\n  background-color: rgb(255, 255, 255);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.indexedStep.accomplished {\n  background-color: #007bff;\n  color: white;\n  border-style: none;\n}\n\n.indexedStep.completed {\n    background-color: #007bff;\n    color: white;\n  }\n\n.indexedStep > svg {\n  font-size: 11px;\n}\n\n.indexedStep .mt-14 {\n  position: absolute;\n  font-size: 12px;\n  text-align: center;\n}\n\n.RSPBprogressBar {\n  height: 2px;\n  width: 200px;\n  line-height: 1;\n  border-radius: 10px;\n  position: relative;\n  background-color: rgb(207, 207, 207);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 0;\n  margin: 20px auto;\n}\n\n.RSPBprogressBar .RSPBstep {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 0;\n  position: absolute;\n  transform: translateX(-50%);\n  transition-property: all;\n  transition-timing-function: ease;\n}\n\n.RSPBprogressBar .RSPBprogressBarText {\n  color: white;\n  font-size: 10px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.RSPBprogressBar .RSPBprogression {\n  position: absolute;\n  transition: width 0.3s ease;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: 10px;\n  background: #007bff;\n  z-index: -1;\n}\n\n@media screen and (max-width: 480px) {\n  .indexedStep {\n    width: 15px;\n    height: 15px;\n    font-size: 6px;\n  }\n}\n\n.single-step-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
